<template>
  <div class="container graybg">
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
        <span>{{ t('servicechildmenu.service2') }}</span>
      </div>
    </div>
    <div class="service-bg" style="padding-bottom:30px;background: #fff;">
    <div class="new-list-bar" >
      <h2 class="title">{{ t('rotary.moduleA.title') }}</h2>
      <p class="subtitle">{{ t('rotary.moduleA.desc') }}
      </p>
      <el-carousel class="carousel" height="400px" arrow="always">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <img :src="item.qrcode" />
        </el-carousel-item>
      </el-carousel>
    </div>
    </div>
    <div class="new-list-bar" style="padding-bottom:30px">
      <h2 class="title">{{ t('rotary.moduleB.title') }}</h2>
      <ul class="ul-list">
            <p class="subtitle">{{ t('rotary.moduleB.desc1title') }}</p>
            <li v-for="item in t('rotary.moduleB.desc').split(';').slice(0,2)" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
      </ul>
      <ul class="ul-list">
            <p class="subtitle">{{ t('rotary.moduleB.desc2title') }}</p>
            <li v-for="item in t('rotary.moduleB.desc').split(';').slice(2,6)" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
      </ul>
      <div class="news-list">
        <img width="1280" src="../../assets/images/jn3.png" />
      </div>
    </div>
    
    
  </div>
</template>
<script setup>
import { ref} from "vue";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const bannerList = ref([
  {
    qrcode: require("../../assets/images/jn1.png"),
  },
  {
    qrcode: require("../../assets/images/jn2.png"),
  }])
  



</script>
<style lang="scss" scoped>
.new-list-bar {
  padding-top:30px;
  padding-bottom:0px;
  .carousel{margin-top:20px;}
  .contact-list {
    padding:30px 0px 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    li {
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      width: 412px;
      height: 240px;
      border-radius: 8px;
      background: #FFFFFF;
      text-align: center;

      span {
        display: block;
      }

      .span-icon-box {
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border-radius: 15px;
        border: 1px solid vars.$base-color;

        img {
          margin-top: 30px;
          width: 40px;
        }
      }

      .span-name {
        margin-top: 16px;
        font-size: 20px;
      }

      .span-details {
        margin-top: 16px;
        font-size: 16px;
      }
    }

  }
  .ul-list {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        flex-direction: row;
        padding: 10px 0px;

        .li-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
        }

        .span-txt {
          margin-left: 10px;
          flex: 1;
          display: block;
          line-height: 32px;
          font-size: 16px;
        }
      }
    }
  .subtitle{
   color:#000;
   text-align: left;
  }
}
.whitespace-pre-line {
  white-space: pre-line;
}
.news-list img{
  box-sizing:border-box;
  // border: 6px solid #f8f8f8;
  // border: 2px solid #d9d9d9;
}
</style>